export var formatSignOrderUser = function formatSignOrderUser(user) {
  if (user == null) return null;

  //remove comma if exists
  var res = user.replace(/,/g, '');
  return res;
};
export default formatSignOrderUser;